// 날짜·시간 도우미 — 브라우저 로컬 시각 기준(학원은 KST). 문자열 형식은 v0.3 과 같다: 날짜 yyyy-MM-dd · 시간 HH:mm
export const DOW = ["월", "화", "수", "목", "금", "토", "일"];

const pad = (n: number) => String(n).padStart(2, "0");

export function ymd(d: Date): string {
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}
export function parseYmd(s: string): Date {
  const [y, m, d] = s.split("-").map(Number);
  return new Date(y, m - 1, d);
}
export const todayStr = () => ymd(new Date());
export function addDays(s: string, n: number): string {
  const d = parseYmd(s);
  d.setDate(d.getDate() + n);
  return ymd(d);
}
/** java.time 과 같은 요일 값: 1=월 … 7=일 */
export function dowValue(s: string): number {
  const g = parseYmd(s).getDay();
  return g === 0 ? 7 : g;
}
export const dowLabel = (s: string) => DOW[dowValue(s) - 1];
export function fmtDate(s: string): string {
  const d = parseYmd(s);
  return `${d.getMonth() + 1}/${d.getDate()}(${dowLabel(s)})`;
}
export function fmtDateLong(s: string): string {
  const d = parseYmd(s);
  return `${d.getMonth() + 1}월 ${d.getDate()}일 (${dowLabel(s)})`;
}
export function relDate(s: string): string {
  const t = todayStr();
  if (s === t) return "오늘";
  if (s === addDays(t, 1)) return "내일";
  if (s === addDays(t, -1)) return "어제";
  return fmtDate(s);
}
export function nowHM(d = new Date()): string {
  return `${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
export function minusMinutesHM(min: number): string {
  return nowHM(new Date(Date.now() - min * 60_000));
}
export function weekOfMonth(s = todayStr()): number {
  return Math.floor((parseYmd(s).getDate() - 1) / 7) + 1;
}
